import { LIMITS } from '@keep/shared';
import { useUploadAttachment } from '../../api/notes';
import { errorMessage } from '../../lib/api';
import { toastError } from '../../stores/toasts';

/** Envoie des images vers une note, en vérifiant la taille avant l'envoi. */
export function useImageUpload() {
  const upload = useUploadAttachment();
  return (noteId: string, files: File[]) => {
    for (const file of files) {
      if (file.size > LIMITS.attachmentBytes) {
        toastError(`« ${file.name} » dépasse ${LIMITS.attachmentBytes / 1024 / 1024} Mo`);
        continue;
      }
      upload.mutate(
        { noteId, file },
        { onError: (error) => toastError(`${file.name} : ${errorMessage(error)}`) },
      );
    }
  };
}
